// @ts-strict-ignore
import * as React from 'react';
import {
    AppStoreReviewSubmissionItemType,
    AppVersionExperiment,
    CustomProductPage,
    InAppEvent,
    TranslationString,
} from '@/types';
import { InAppEventCard } from '@/components/AppStoreItems/InAppEventCard';
import { CustomProductPageCard } from '@/components/AppStoreItems/CustomProductPageCard';
import { AppVersionExperimentCard } from '@/components/AppStoreItems/AppVersionExperimentCard';
import { CommonSubmissionItemCardProps } from '@/components/AppStoreItems/AppStoreItemsCard';
import { Nullable, StepRunComponentProps } from '@/typescriptHelpers';

export const renderReviewsSubmissionItemCard = ({
    item,
    reviewSubmissionItemId,
    type,
    ...rest
}: {
    item: InAppEvent | CustomProductPage | AppVersionExperiment | null;
    reviewSubmissionItemId: string;
    type: AppStoreReviewSubmissionItemType;
    stepRunComponentProps: Nullable<StepRunComponentProps>;
} & CommonSubmissionItemCardProps) => {
    if (!item) {
        return null;
    }

    switch (type) {
        case AppStoreReviewSubmissionItemType.AppEvent: {
            const i = item as InAppEvent;
            return (
                <InAppEventCard key={i.id} reviewSubmissionItemId={reviewSubmissionItemId} inAppEvent={i} {...rest} />
            );
        }
        case AppStoreReviewSubmissionItemType.CustomProductPage: {
            const i = item as CustomProductPage;
            return (
                <CustomProductPageCard
                    key={i.id}
                    reviewSubmissionItemId={reviewSubmissionItemId}
                    customProductPage={i}
                    {...rest}
                />
            );
        }
        case AppStoreReviewSubmissionItemType.AppStoreVersionExperiment: {
            const i = item as AppVersionExperiment;
            return (
                <AppVersionExperimentCard
                    key={i.id}
                    reviewSubmissionItemId={reviewSubmissionItemId}
                    appVersionExperiment={i}
                    {...rest}
                />
            );
        }
        default:
            return null;
    }
};

export const idForSubmissionItem = (
    item: CustomProductPage | InAppEvent | AppVersionExperiment,
    category: AppStoreReviewSubmissionItemType,
): string => {
    switch (category) {
        case AppStoreReviewSubmissionItemType.CustomProductPage:
            return (item as CustomProductPage).versions?.[0]?.id;
        case AppStoreReviewSubmissionItemType.AppEvent:
            return (item as InAppEvent).id;
        case AppStoreReviewSubmissionItemType.AppStoreVersionExperiment:
            return (item as AppVersionExperiment).id;
        default:
            return null;
    }
};

export const getRelevantTranslationStrings = (
    useWorkingBranch: boolean,
    workingBranchKeys: TranslationString[],
    keys: TranslationString[],
) => {
    return useWorkingBranch ? workingBranchKeys : keys;
};
